import styled from 'styled-components';
import { black, white, grey40, grey60, grey80 } from 'Styles/colors';
import { fontTitle, fontBody } from 'Styles/fonts';
import Icon from '../../../Icons/Icon';
import Button from '../../../Button/Button';

export const PlusIcon = styled(Icon).attrs({
  name: 'plus'
})`
  color: ${black};
`;

export const GiftingButton = styled.button`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  height: 48px;
  border: none;
  background: none;
  width: 100%;
  cursor: pointer;
  ${({ $hasDiscount }) =>
    $hasDiscount && `border-bottom: 1px solid ${grey40};`};
`;

export const GiftingText = styled.span`
  ${fontTitle(14)};
  color: ${black};
`;

export const DiscountContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 10px 0;
  height: 36px;
`;

export const Prefix = styled.span`
  ${fontTitle(14)};
  line-height: 21px;
  margin-right: 6px;
  white-space: nowrap;
`;

export const TagIcon = styled(Icon).attrs({
  name: 'tag'
})`
  color: ${grey80};
`;

export const DiscountCode = styled.span`
  ${fontBody(14)};
  margin-left: 2px;
  color: ${grey80};
`;

export const DiscountBadge = styled.div`
  position: relative;
  background: ${grey60};
  color: ${white};
  ${fontTitle(14)};
  line-height: 36px;
  white-space: nowrap;
  padding: 0 10px;
  border-radius: 3px;
  margin: 0 10px;

  &:before,
  &:after {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 7px;
    border-radius: inherit;
    background: inherit;
    content: '';
    transform: rotate(45deg) skew(11deg, 11deg);
    z-index: -1;
  }

  &:before {
    left: -9px;
  }

  &:after {
    right: -9px;
  }
`;

export const CodeWrap = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-self: center;
`;

export const Code = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: end;
`;

export const ButtonGroup = styled.div`
  margin-bottom: 16px;

  & > * {
    line-height: 48px;
    text-align: center;
  }

  *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const CheckoutButton = styled(Button).attrs({
  variant: 'primary',
  size: 'large',
  isFull: true
})`
  line-height: 48px;
`;

export const CartFooter = styled.div`
  background-color: ${white};
  padding: 0px 16px;

  ${ButtonGroup}:only-child {
    padding-top: 16px;
  }
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
`;
